// I link nel testo dei messaggi. Lo stesso criterio del server
// (apps/messages/anteprima_link.py): http o https fino al primo spazio, senza
// la punteggiatura della frase in coda. Altri schemi (javascript:, file:) non
// diventano mai link.
const LINK = /https?:\/\/[^\s<>"]+/gi;
const CODA = '.,;:!?\'"»”’';

const pulisci = link => {
  let fine = link;
  while (fine && (CODA.includes(fine[fine.length - 1])
    || (fine.endsWith(')') && (fine.match(/\(/g) || []).length < (fine.match(/\)/g) || []).length))) {
    fine = fine.slice(0, -1);
  }
  return fine;
};

// Il testo a pezzi: [{ testo }, { link }, { testo }, ...]
export function dividiLink(testo) {
  const pezzi = [];
  let da = 0;
  for (const trovato of (testo || '').matchAll(LINK)) {
    const link = pulisci(trovato[0]);
    if (!link) continue;
    if (trovato.index > da) pezzi.push({ testo: testo.slice(da, trovato.index) });
    pezzi.push({ link });
    da = trovato.index + link.length;
  }
  if (da < (testo || '').length) pezzi.push({ testo: testo.slice(da) });
  return pezzi;
}

export const primoLink = testo => dividiLink(testo).find(p => p.link)?.link || null;
